var app = angular.module('jv.Admin.Users',[
    'ngRoute',
    'ngSanitize',
    'jv',
    'jv.Common.Modal',
    'JV.Core.Directives',
    'jv.Common.Directives.Tooltip',
    'jv.Common.Directives.Breadcrumbs',
    'jv.Common.Directives.SortList',
    'jv.Admin.Users.Employee.Service',
    'jv.Admin.Users.Agency.Service',
    'jv.Admin.Users.Settings.Service',
    'jv.Admin.Users.NavService',
    'jv.Common.Directives.Formtemplate',
    'jv.Admin.Users.CommonListActions.Factory',
    'jv.directives',
    'jv.Common.Directives.HideOnBlur',
    'jv.services',
    'jv.Common.EmployeeSelect',
    'jv.React.Admin.Users.AccessGroups'
]);

app.value('modalTemplateUrl', '../../htm/common/modal.html');
app.config(['$routeProvider', '$provide', function($routeProvider, $provide) {

        var getBreadcrumbResolveOptions = function(options) {
            var optionsLength = options.length;
            var breadcrumbOptions = [{
                linkText: i18n['USERS'],
                link: '#/users/introduction'
            }, {
                linkText: i18n['EMPLOYEES'],
                link: '#/users/employees'
            }, {
                linkText: i18n['AGENCIES'],
                link: '#/users/agencies'
            }, {
                linkText: i18n['ADMIN_MANAGE_EMPLOYEE_FIELDS'],
                link: '#/users/settings'
            }, {
                linkText: i18n['ADMIN_USERS_SUB_NAV_EMPLOYEE_DATA_SYNC_LOG'],
                link: '#/users/datasync/employee'
            }, {
                linkText: i18n['ADMIN_USERS_SUB_NAV_SFTP_SETTINGS'],
                link: '#/users/datasync/settings'
            }, {
                linkText: i18n['ADMIN_USERS_SUB_NAV_ROLES_BREADCRUMB'],
                link: '#/users/roles/list'
            },{
            	 linkText: i18n['ADMIN_USERS_SUB_NAV_DELETE_THRESHOLD_SETTINGS'],
                 link: '#/users/deletethreshold/settings'
            }];
            var breadcrumbs = {
                backText: i18n['GO_BACK_TO'],
                previousText: i18n['PREVIOUS'],
                menuText: i18n['MENU'],
                links: []
            };
            var i = 0;

            for (i; i < optionsLength; i++) {
                breadcrumbs.links.push(breadcrumbOptions[options[i]]);
            }

            return breadcrumbs;
        };

        /*introduction page (default)*/
        var adminUserBaseRouteObj = {
            controller: 'jvAdminUsersLandingController',
            templateUrl: 'introduction.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([0]);
                }
            }
        };
        
        $routeProvider.when('/users', adminUserBaseRouteObj);
        $routeProvider.when('/users/introduction', adminUserBaseRouteObj);
        
        $routeProvider.when('/users/employees', {
            controller: 'jvAdminUsersEmplyeeListController',
            templateUrl: 'employees.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/accessGroups', {
            controller: 'AdminUsersAccessGroupsCtrl',
            templateUrl: 'accessGroups.html',
            resolve: {
                accessGroupRedirect: function($q) {
                    var deferred = $q.defer();
                    if (window.companyProperties.isODSFlagEnabled) {
                        deferred.resolve(true);
                    } else {
                         window.location.href = window.jvUrls.admin + '/info/accessDenied.html';
                        deferred.resolve(false);
                    }
                    return deferred.promise;
                },
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/employees/:roleCode', {
            controller: 'jvAdminUsersEmplyeeListController',
            templateUrl: 'employees.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });
        $routeProvider.when('/users/employees/msg/:message', {
            controller: 'jvAdminUsersEmplyeeListController',
            templateUrl: 'employees.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/employee/details/:id', {
            controller: 'jvAdminUsersEmplyeeDetailsController',
            templateUrl: 'employeeDetails.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/employee/details/:id/:index/:count', {
            controller: 'jvAdminUsersEmplyeeDetailsController',
            templateUrl: 'employeeDetails.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/employee/details/:id/:index/:count/:page', {
            controller: 'jvAdminUsersEmplyeeDetailsController',
            templateUrl: 'employeeDetails.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/employee/edit/:id/:index/:count', {
            controller: 'jvAdminUsersEmplyeeDetailsController',
            templateUrl: 'employeeAdd.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });

        $routeProvider.when('/users/employee/add', {
            controller: 'jvAdminUsersEmployeeAddController',
            templateUrl: 'employeeAdd.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });
        
        $routeProvider.when('/users/agencies', {
            controller: 'jvAdminUsersAgencyListController',
            templateUrl: 'agencies.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([2, 0]);
                }
            }
        });
        
        $routeProvider.when('/users/agencies/:message', {
            controller: 'jvAdminUsersAgencyListController',
            templateUrl: 'agencies.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([2, 0]);
                }
            }
        });

        $routeProvider.when('/users/agency/details/:id/:index/:count/:page', {
            controller: 'jvAdminUsersAgencyDetailsController',
            templateUrl: 'agencyDetails.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([2, 0]);
                }
            }
        });
        
        $routeProvider.when('/users/agency/add', {
            controller: 'jvAdminUsersAgencyAddController',
            templateUrl: 'agencyAdd.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([2, 0]);
                }
            }
        });

        $routeProvider.when('/users/settings', {
            controller: 'jvAdminUsersEmplyeeSettingsController',
            templateUrl: 'settings.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([3, 0]);
                }
            }
        });
        
        $routeProvider.when('/users/datasync/employee', {
            controller: 'jvAdminUsersDataSyncEmployeeListController',
            templateUrl: 'employeeDataSyncLog.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([4, 0]);
                }
            }
        });

        $routeProvider.when('/users/datasync/settings', {
            controller: 'jvAdminUsersDataSyncEmployeeSettingsController',
            templateUrl: 'employeeDataSyncSettings.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([5, 0]);
                }
            }
        });

        $routeProvider.when('/users/roles/list', {
            controller: 'jvAdminUsersRolesListController',
            templateUrl: 'roles/list.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([6, 0]);
                }
            }
        });

        $routeProvider.when('/users/role/:id', {
            controller: 'jvAdminUsersRolesDetailsController',
            templateUrl: 'roles/details.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([6, 0]);
                }
            }
        });

        $routeProvider.when('/users/employees/details/:id/:index/:count/:page',{
            controller: 'jvAdminUsersEmplyeeDetailsController',
            templateUrl: 'employeeDetails.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([1, 0]);
                }
            }
        });
        
        $routeProvider.when('/users/deletethreshold/settings', {
            controller: 'jvAdminUsersDeleteThresholdSettingsController',
            templateUrl: 'employeeDeleteThresholdSettings.html',
            resolve: {
                breadcrumbsResolve: function() {
                    return getBreadcrumbResolveOptions([7, 0]);
                }
            }
        });
        
        $routeProvider.otherwise({redirectTo: '/users/introduction'});
    }
]);

app.value("enumToValueMap", {
        subsidiaries: {},
        departments:{},
        locations:{},
        roles:{
            'ROLE_RECRUITER':'Recruiter',
            'ROLE_HIRING_MANAGER':'Hiring Manager',
            'ROLE_RESEARCH':'Engage User',
            'ROLE_ADMINISTRATOR':'Administrator',
            'ROLE_SCHEDULER':'Scheduler',
            'ROLE_HMMANAGER':'HM Manager',
            'ROLE_HUMAN_RESOURCE':'Human Resources',
            'ROLE_SUPERUSER': 'Super User',
            'ROLE_JOBAPPROVER': 'Job Approver',
            'ROLE_EMPLOYEE': 'Employee',
            'ROLE_ONBOARDING_ADMIN': 'Onboarding Administrator',
            'ROLE_ONBOARDING_ORCHESTRATOR': 'Onboarding Orchestrator'
        },
        inviteStatuses: {
        	'4': 'INVITE_STATUS_ACCEPTED',
            '3': 'INVITE_STATUS_READ',
            '1': 'INVITE_STATUS_NOT_READ',
            '13': 'INVITE_STATUS_NOT_YET_INVITED',
            '10': 'INVITE_STATUS_PENDING'
        },
        sorts:{
            'FirstName':'First Name',
            'LastName' :'Last Name',
            'InviteStatus':'Invite Status',
            'Company':'Company',
            'Department':'Department',
            'Location':'Location',
            'EmployeeId':'ID',
            'Publisher':'Publisher',
            'FacebookApp':'Facebook App',
            'Relevance':'Relevance'
       }
    }
);
